function DatabaseVerification() {
    return (
        <div>
            <h2>Database Verification</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default DatabaseVerification;